module.exports = __webpack_public_path__ + "img/select-lang-btn-en.004ad488.png";